import React, { FC } from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import FhirLoader from '../../../../FhirLoader'
import { GoalBundle } from '../../../../../types/FHIRTypes/Bundle'
import { isGoalBundle } from '../../../../../typeGuards/fhirTypes'
import { GoalTable } from '@teschglobal/tg-fhir-react-components'

type GoalListProps = {
  goalData: GoalBundle;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
}

const GoalList: FC<GoalListProps> = ({ goalData, handleChangePage, isFetching, totalPages, currentPage }) => {
  if (!isGoalBundle(goalData)) return null

  const patientGoals = goalData && goalData.entry ? goalData.entry.map((goal) => goal.resource) : []

  if (isFetching) {
    return <FhirLoader message='Loading...' />
  }

  return (
    <>
      {
        goalData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <span role="status" aria-live="polite">{goalData?.total.toLocaleString()} record(s) found</span>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
      <GoalTable
        goals={patientGoals}
      />
      {
        goalData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
    </>
  )
}

export default GoalList